<template>
  <div>
    <event-details v-if="getterPopupName === 'EventDetails'"
                  :eventOptions="eventOptions" />

    <div class="status-info" v-if="allOperational">
      <i class="fa fa-check-circle" />
      <p>All services are operational</p>
    </div>

    <div class="status-table">
      <div class="modules">
        <p>Service</p>
        <div class="sub-modules">
          <p>Module</p>
          <p>Status</p>
          <p v-if="isDesktop()">Duration</p>
          <p v-if="isDesktop()">Reason</p>
          <p v-if="!isDesktop()"></p>
        </div>
      </div>

      <div v-for="(data, index) in services" :key="index" class="modules">
        <div class="head">
          <p>{{data.title}}</p>
        </div>

        <div :class="{'align-center': data.list.length === 1}">
          <div v-for="(subData, subIndex) in data.list" :key="subIndex"
              class="sub-modules" @click="showDetails(subData, data.title)">
            <p>
              {{subData.module}}
              <i v-if="subData.additional_info" class="fa fa-info-circle">
                <md-tooltip md-direction="top">{{subData.additional_info}}</md-tooltip>
              </i>
            </p>
            <p class="status">
              {{subData.status_text}}
              <i :class="{'fa': true, [subData.css]: true}" />
            </p>
            <p v-if="isDesktop()">
              <span v-for="(time, timeIndex) in startEnd(subData.start_time, subData.end_time)"
                    :key="timeIndex">
                <b>{{time.title}}</b>:
                {{time.value}}
              </span>
              <span v-if="!subData.start_time">-</span>
            </p>
            <p v-if="isDesktop()">
              {{subData.reason || '-'}}
            </p>
            <p v-if="!isDesktop()">
              <u @click="showDetails(subData, data.title)">View</u>
            </p>
          </div>
        </div>
      </div>

      <table-loader v-if="!services.length" :css="{'border-layout': !isDesktop()}" />
    </div>
  </div>
</template>

<script>
import EventDetails from '@/components/Status/Details'
import TableLoader from '@/components/global/TableLoader'

import ApiServices from '@/services/api/serviceStatus'
import moment from 'moment'
import { openPopup } from '@/utils/helpers'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'LiveEvents',
  components: { EventDetails, TableLoader },
  data () {
    return {
      services: [],
      serviceOrder: {
        'Virtual Account': [
          'Yesbank',
          'RBL',
          'DBS'
        ],
        'UPI': [
          'Yesbank',
          'ICICI'
        ],
        'Payouts': [
          'IMPS',
          'NEFT',
          'RTGS',
          'UPI'
        ],
        'Verification': [
          'Bank Account',
          'UPI ID'
        ],
        'UPI Collections': [
          'Yesbank'
        ]
      },
      eventOptions: {},
      allOperational: false
    }
  },
  computed: {
    ...mapGetters(['getterPopupName'])
  },
  created () {
    this.liveEvents()
  },
  methods: {
    openPopup,
    moment,
    ...mapMutations(['SET_UPCOMING_EVENTS_COUNT']),
    liveEvents () {
      ApiServices.liveEvents().then(response => {
        let data = response.data
        let products = data.services
        this.allOperational = true
        this.SET_UPCOMING_EVENTS_COUNT(data.upcoming_events_total)

        for (let title in this.serviceOrder) {
          let serviceList = this.serviceOrder[title]
          let currentModule = products[title]
          let list = []
          serviceList.forEach(el => {
            let currentObj = currentModule[el]
            let css = ''
            if (currentObj.status) {
              css = 'fa-check-circle'
            } else {
              css = 'fa-exclamation-circle'
              if (currentObj.status_text !== 'Down') {
                css += ' partial'
              }
            }
            list.push({
              module: el,
              css,
              ...currentObj
            })

            if (!currentObj.status) {
              this.allOperational = false
            }
          })
          this.services.push({
            title, list
          })
        }
      })
    },
    showDetails (data, service) {
      this.openPopup('EventDetails')
      this.eventOptions = {
        ...data,
        service
      }
    },
    startEnd (start, end) {
      if (!start) {
        return
      }

      const format = moment(start).isSame(end || moment(), 'year') ? 'Do MMM, hh:mm a' : 'Do MMM YYYY, hh:mm a'

      let obj = [{
        title: 'From',
        value: moment(start).format(format)
      }]
      if (end) {
        obj.push({
          title: 'To',
          value: moment(end).format(format)
        })
      }
      return obj
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .status-info {
    box-shadow: $card-shadow;
    border-radius: 5px;
    padding: 15px;

    border-left: 10px solid $increase;
    margin-bottom: 15px;
    background: $white;
  }

  .fa-check-circle {
    color: $increase;
  }

  .status-table {
    border: 2px solid $grey-outline;
    border-radius: 5px;
    background: $white;

    .modules {
      border-bottom: 2px solid $grey-outline;

      &:first-child {
        @include highlight-text($secondary, 15px);
        padding: 10px 0;
        background: $primary-light;
      }
      &:last-child {
        border-bottom: none !important;
      }

      .head {
        @include custom-flex();
        @include highlight-text($secondary, 15px);
        border-right: 2px solid $grey-outline;
        background: $primary-light;
      }
      .align-center {
        display: flex;
        align-items: center;

        .sub-modules {
          width: 100%;
          height: 100%;
        }
      }

      p {
        padding: 8px 0;
      }

      .sub-modules {
        border-bottom: 2px solid $grey-outline;
        align-items: center;

        &:last-child {
          border-bottom: none !important;
        }

        p {
          flex: 1;

          &.status {
            @include custom-flex();
          }

          span {
            display: block;
          }
          i {
            margin-left: 5px;

            &.fa-exclamation-circle {
              color: $decrease;

              &.partial {
                color: #f8bd15 !important;
              }
            }
            &.fa-info-circle {
              color: rgba(101, 109, 113, .5);
            }
          }
        }
      }
    }
  }

  .desktop {
    .modules {
      @include custom-grid-col(100px auto);

      .sub-modules {
        @include custom-grid-col(20% 15% auto 20%, 5px);
      }

      &:nth-child(n+2) {
        .sub-modules {
          background: $white;
          cursor: pointer;

          &:hover {
            filter: brightness(0.9);
          }
        }
      }
    }
  }

  .mobile, .tablet {
    .modules {
      @include custom-grid-col(85px auto);

      .sub-modules {
        @include custom-grid-col(auto 30% 20%);

        u {
          color: $primary;
        }
      }
    }
  }
</style>
